import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import mask from '@alpinejs/mask';
import './include/global';
import ABTasty from '../ab/abtasty';
import prefetchLinks from "./include/prefetchLinks";
import { initPageDOM } from "../pageInit";
import {
    sendBaseDataLayer, sendEventDataLayer,
    sendPageActionDatas,
    sendPageDatas,
    sendProductDatas,
    sendTunnelForm
} from "./include/taggage";
import { Localisation, UserData } from '../../types/user'
import { initPhonePrefixStore } from '../tunnels/components/phonePrefixComponent';

Alpine.plugin(intersect);
Alpine.plugin(mask);
initPhonePrefixStore();

window.Alpine = Alpine;

try {
    window['sendBaseDataLayerFct'] = sendBaseDataLayer
    window['sendEventDataLayerFct'] = sendEventDataLayer
    window['sendTunnelFormFct'] = sendTunnelForm
    window['sendPageDatasFct'] = sendPageDatas
    window['sendPageActionDatasFct'] = sendPageActionDatas
    window['sendProductDatasFct'] = sendProductDatas
} catch (e) {
    console.log('Failed to expose dataLayer functions on window', e);
}

document.addEventListener('DOMContentLoaded', () => {
    try {
        Alpine.start();
        ABTasty.start();
        initPageDOM();
        prefetchLinks();

        for(const [key, value]  of new URLSearchParams(window.location.search).entries()){
            if (key === 'utm_source' || key === 'utm_campaign' || key === 'qwp_id') {
                window.localStorage.setItem(key, value);
            }
        }

        const position_gps = window.localStorage.getItem('position_gps');
        if (position_gps !== null) {
            if (window.localStorage.getItem('user_loc') !== null) {
                window.localStorage.removeItem('position_gps');
            } else {
                window.localStorage.setItem('user_loc', position_gps);
            }
        }

        const user_loc = window.localStorage.getItem('user_loc');
        if (user_loc !== null) {
            window.localStorage.removeItem('user_loc');
        }

        const data_selected = window.localStorage.getItem('data-selected');
        if (data_selected !== null) {
            window.localStorage.removeItem('data-selected');
        }

        const userData = window.localStorage.getItem('user_data');
        if (userData !== null) {
            try {
                const userDataObject = JSON.parse(userData);
                if (userDataObject.zip !== undefined && userDataObject.city !== undefined) {
                    userDataObject.localisation = {
                        zip: userDataObject.zip,
                        city: userDataObject.city
                    }
                    delete userDataObject.zip;
                    delete userDataObject.city;
                    delete userDataObject.telephone;
                    window.localStorage.setItem('user_data', JSON.stringify(userDataObject));
                }
                if (userDataObject.shop && userDataObject.shop.url) {
                    // fix the url if it's like "/espace-conseil/67/https://www.tryba.com/espace-conseil?shop=G640"
                    const url = userDataObject.shop.url;
                    userDataObject.shop.url = url.slice(url.indexOf('/http') + 1)
                    window.localStorage.setItem('user_data', JSON.stringify(userDataObject));
                }
            } catch (e) {
                console.log('Error parsing user data for normalization', e);
            }
        } else {
            let localisation: Localisation|null = null;
            if (user_loc !== null) {
                try {
                    const user_loc_object = JSON.parse(user_loc);
                    if (user_loc_object.length > 0){
                        if (user_loc_object[0].zip && user_loc_object[0].city) {
                            // @ts-ignore
                            localisation = {
                                zip: user_loc_object[0].zip,
                                city: user_loc_object[0].city,
                            }
                        }
                    }
                } catch (e) {
                    console.log('Error parsing user_loc for normalization', e);
                }
            }
            window.localStorage.setItem('user_data', JSON.stringify({localisation: localisation, shop: null} as UserData));
        }
    } catch (e) {
        console.log('Error in Alpine', e);
    }
});


